import httpClient from "@plugins/http";
import { notNull } from "@utils/var.check.ts";
import { ApiResponse } from "@apis/api.ts";
import { AppMetadataModel } from "@plugins/richtext/types.ts";

const fetchIndependentAppContext = (requestData) => {
  return httpClient.get(`/apis/app/independent/generate-context`, requestData);
};

const fetchStudentGroupAppContext = (requestData) => {
  return httpClient.get(`/apis/app/student-group/generate-context`, requestData);
};

const installApp = (requestData) => {
  return httpClient.post(`/apis/app/install`, requestData);
};

const uninstallApp = (requestData) => {
  return httpClient.post(`/apis/app/uninstall`, requestData);
};

const fetchAppNameList = () => {
  return httpClient.get(`/apis/app/name/list`);
};

const fetchManageAppList = (requestData) => {
  const data = new URLSearchParams();
  Object.keys(requestData).forEach((key) => {
    if (notNull(requestData[key])) {
      data.append(key, requestData[key]);
    }
  });
  return httpClient.get("/apis/app/manage-resource/list", {
    params: data,
  });
};

const fetchAppMetadata = (uuid: string): Promise<ApiResponse<AppMetadataModel>> => {
  return httpClient.get(`/apis/app/metadata/${uuid}`);
};

export default {
  fetchIndependentAppContext,
  fetchStudentGroupAppContext,
  installApp,
  uninstallApp,
  fetchAppNameList,
  fetchManageAppList,
  fetchAppMetadata,
};
